<div class="location-modal">
  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-lavuro m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-capitalize">Buscar Ubicación</span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="m-0 p-0">
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <input class="form-control" type="text" (ngModelChange)="resetSelection()"
            (keydown.enter)="$event.preventDefault()" [(ngModel)]="initialLocation.address"
            placeholder="Buscar Direccion (seleccione un item de la lista para aceptar)" autocorrect="off"
            autocapitalize="off" spellcheck="off" type="text" #search>
        </div>

        <!-- Mapa con evento click -->
        <google-map [center]="{lat: latitude, lng: longitude}" [zoom]="zoom" height="350px" width="100%"
          (mapClick)="onMapClick($event)">
          <map-marker [position]="{lat: selectedLatitude, lng: selectedLongitude}" [options]="{draggable: false}">
          </map-marker>
        </google-map>

        <div class="pull-left">
          <div>Latitud: {{selectedLatitude}} | Longitud: {{selectedLongitude}}</div>
        </div>
        <div class="pull-right">
          <button mat-raised-button type="button" class="m-0 ml-1 btn btn-link" (click)="dialog.close(false)">
            Cancelar
          </button>
          <button mat-raised-button type="button" class="m-0 ml-1 btn btn-lavuro" (click)="onSubmit()"
            *ngIf="selectedLatitude && selectedLongitude">
            <i class="material-icons">place</i> Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>
</div>